export default {
  data() {
    return {
      answer: {
        id: this.component.id,
        optionID: this.component.answer?.optionID ?? '',
        value: this.component.answer?.value ?? '',
        stepID: '', // added in the 'triggerFeedback' function
        type: this.component.type,
        subType: this.component.settings.type ?? '',
      },
    }
  },
}
